<template>
  <div class="row">
    <div class="col s12 m12 l6 offset-l3">
      <div class="card">
        <div class="card-action white">
          <h5 v-if="!userOTP">Welcome, please join the iRecharge community</h5>
          <h5 v-else>Final Step Verification</h5>
        </div>
        <div class="card-content" v-if="!userOTP">
          <form id="formRegister" @submit.prevent="register">
            <div class="row">
              <div class="input-field col s6 m6">
                <input type="text" v-model="fields.firstname" id="firstname" />
                <label for="firstname">First Name</label>
              </div>
              <div class="input-field col s6 m6">
                <input type="text" v-model="fields.lastname" id="lastname" />
                <label for="lastname">Last Name</label>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12 m12">
                <input type="email" v-model="fields.email" id="email" />
                <label for="email">Email Address</label>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12 m12">
                <input type="text" v-model="fields.phone" id="phone" />
                <label class="active" for="phone">Phone number</label>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12 m6">
                <input
                  id="password"
                  type="password"
                  v-model="fields.password"
                />
                <label for="password">Password</label>
              </div>
              <div class="input-field col s12 m6">
                <input
                  id="cpassword"
                  type="password"
                  v-model="fields.repeat_password"
                />
                <label for="cpassword">Confirm Password</label>
              </div>
            </div>
            <div class="row">
              <div
                class="col s12 m12 l12"
                style="margin-bottom: 15px; text-align: left"
              >
                <label><strong>Select Solution</strong></label>
              </div>
              <div class="col s6 m3 l3 option">
                <label>
                  <input
                    class="with-gap"
                    value="user"
                    v-model="fields.signopt"
                    name="signopt"
                    type="radio"
                    :disabled="loading"
                    checked
                  />
                  <span>User</span>
                </label>
              </div>
              <div class="col s6 m3 l3 option">
                <label>
                  <input
                    class="with-gap"
                    value="vendor"
                    v-model="fields.signopt"
                    name="signopt"
                    type="radio"
                    :disabled="loading"
                  />
                  <span>Merchant</span>
                </label>
              </div>
              <div class="col s6 m3 l3 option">
                <label>
                  <input
                    class="with-gap"
                    value="api"
                    v-model="fields.signopt"
                    name="signopt"
                    type="radio"
                    :disabled="loading"
                  />
                  <span>API</span>
                </label>
              </div>
              <div class="col s6 m3 l3 option">
                <label>
                  <input
                    class="with-gap"
                    value="corporate"
                    v-model="fields.signopt"
                    name="signopt"
                    type="radio"
                    :disabled="loading"
                  />
                  <span>Corporate</span>
                </label>
              </div>
            </div>
            <div class="form-field">
              <div v-if="loading">
                <img src="ui/img/loading.svg" alt="Time Loader" />
                <p><i>Loading...</i></p>
              </div>
              <div v-else>
                <button
                  id="registerBtn"
                  class="btn-large waves-effect green darken-2 waves-dark"
                  type="submit"
                  style="width:100%;"
                >
                  Sign Up
                </button>
              </div>
            </div>
          </form>
          <br />
        </div>
        <div class="card-content" v-else>
          <form id="otpForm" @submit.prevent="verifyOTP">
            <div class="row">
              <div class="input-field col s12 m12">
                <input type="text" v-model="user.otp" id="otp" />
                <label for="otp">Enter OTP</label>
              </div>
            </div>
            <div class="form-field">
              <div v-if="loading">
                <img src="ui/img/loading.svg" alt="Time Loader" />
                <p><i>Loading...</i></p>
              </div>
              <div v-else>
                <button
                  id="sendOTP"
                  class="btn-large waves-effect green darken-2 waves-dark"
                  style="width:100%;"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    $('select').formSelect()
    this.fields.signopt = 'user'
    if (localStorage.getItem('phone') !== null) {
      var phone = localStorage.getItem('phone')
      this.fields.phone = phone
      $('#phone').val(phone)
    }
    M.updateTextFields()
  },
  data() {
    return {
      loading: false,
      user: {
        action: 'verify_otp'
      },
      userOTP: false,
      fields: {
        relocate: 'register',
        action: 'register'
      }
    }
  },
  methods: {
    register() {
      if (this.ValidateData()) {
        this.loading = true
        // set form data
        var bodyFormData = new FormData()
        bodyFormData.set('relocate', this.fields.relocate)
        bodyFormData.set('action', this.fields.action)
        bodyFormData.set('phone', this.fields.phone)
        bodyFormData.set('password', this.fields.password)
        bodyFormData.set('repeat_password', this.fields.repeat_password)
        bodyFormData.set('email', this.fields.email)
        bodyFormData.set('firstname', this.fields.firstname)
        bodyFormData.set('lastname', this.fields.lastname)
        bodyFormData.set('signopt', this.fields.signopt)
        this.axios
          .post('control1.php', bodyFormData)
          .then(response => {
            if (response.data.status == 1) {
              $('.toast').hide()
              // $('#registerBtn').disabled = true
              if (this.fields.signopt != 'user') {
                M.toast({ html: response.data.message, classes: 'success' })
                setTimeout(() => {
                  window.location.assign('profile.php')
                }, 3000)
              } else {
                this.userOTP = true
                M.toast({
                  html: 'Kindly enter the OTP sent to your mobile number',
                  classes: 'success'
                })
                this.loading = false
              }
            } else {
              this.loading = false
              $('.toast').hide()
              M.toast({ html: response.data.message, classes: 'info' })
            }
          })
          .catch(error => {
            $('.toast').hide()
            M.toast({
              html: 'Could not send request, check network.',
              classes: 'error'
            })
            this.loading = false
          })
      }
    },
     
    verifyOTP() {
      if (this.user.otp != '') {
        // 08079184672
        this.loading = true
        this.user.username = this.fields.email
        this.user.passcode = this.hash(this.user.username)
        this.axios
          .post('https://irecharge.com.ng/api/misc/verify_otp.php', this.user)
          .then(response => {
            if (response.data.status == 0) {
              $('.toast').hide()
              this.loading = false
              this.userOTP = false
              document.getElementById('myNav').style.width = '100%'
              M.toast({
                html: response.data.message,
                classes: 'success',
                displayLength: 6000
              })
              // State lifting to change the current page to login page
              $emit('change-page', 'login')
            } else {
              this.loading = false
              $('.toast').hide()
              M.toast({ html: response.data.message, classes: 'info' })
            }
          })
          .catch(error => {
            $('.toast').hide()
            M.toast({
              html: 'Could not send request, check network.',
              classes: 'error'
            })
            this.loading = false
          })
      } else {
        $('.toast').hide()
        M.toast({ html: 'OTP field is required', classes: 'info' })
      }
    },
    ValidateData() {
      if (this.fields.email) {
        if (this.fields.phone) {
          if (this.fields.phone.toString().length === 11) {
            if (this.fields.password) {
              if (this.fields.repeat_password) {
                if (this.fields.repeat_password == this.fields.password) {
                  if (this.fields.signopt) {
                    return true
                  } else {
                    $('.toast').hide()
                    M.toast({
                      html: 'Please select a category',
                      classes: 'info'
                    })
                  }
                } else {
                  $('.toast').hide()
                  M.toast({
                    html: 'Confirm password must match',
                    classes: 'info'
                  })
                }
              } else {
                $('.toast').hide()
                M.toast({
                  html: 'Repeat password is required!',
                  classes: 'info'
                })
              }
            } else {
              $('.toast').hide()
              M.toast({ html: 'Password field is required!', classes: 'info' })
            }
          } else {
            $('.toast').hide()
            M.toast({
              html: 'Phone number must be 11 characters',
              classes: 'info'
            })
          }
        } else {
          $('.toast').hide()
          M.toast({ html: 'Phone number is required!', classes: 'info' })
        }
      } else {
        $('.toast').hide()
        M.toast({ html: 'E-mail field is required!', classes: 'info' })
      }
    },
    hash(ref) {
      let passcode = '123NDSx'
      let encrypted = CryptoJS.HmacSHA512(ref, passcode)
      return encrypted.toString()
    }
  }
}
</script>
<style scoped>
label {
  font-size: 1rem;
  color: #9e9e9e;
  font-weight: bold;
}
.option {
  margin-bottom: 25px;
  text-align: left;
}
.card-content {
  padding: 0px 24px 24px;
}
.card .card-action {
  padding: 6px 24px;
}
.row {
  margin-bottom: 0px;
}
.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-top: 1rem;
  border: 1px solid transparent;
  border-radius: 0px;
}
.alert-success {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
}
</style>
